(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-figma"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const syncBannerVideos = () => {
      const desktop = window.matchMedia('(min-width: 990px)').matches;
      document.querySelectorAll('[data-banner-figma-media]').forEach((root) => {
        const deskVideo = root.querySelector('.banner-figma__video--desktop video');
        const mobVideo = root.querySelector('.banner-figma__video--mobile video');
        if (deskVideo) {
          deskVideo.muted = true;
          if (!mobVideo || desktop) deskVideo.play().catch(() => {});
          else deskVideo.pause();
        }
        if (mobVideo) {
          mobVideo.muted = true;
          if (desktop) mobVideo.pause();
          else mobVideo.play().catch(() => {});
        }
      });
    };
    window.addEventListener('resize', syncBannerVideos);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncBannerVideos);
    } else {
      syncBannerVideos();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["devices-figma"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('devices-figma')) {
    customElements.define(
      'devices-figma',
      class DevicesFigma extends HTMLElement {
        connectedCallback() {
          this.tabs = this.querySelectorAll('[data-tab]');
          this.panels = this.querySelectorAll('[data-panel]');
          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.activate(tab.dataset.tab));
          });
          this.querySelectorAll('[data-dir]').forEach((btn) => {
            btn.addEventListener('click', () => this.scrollBy(Number(btn.dataset.dir)));
          });
        }
        activate(id) {
          this.tabs.forEach((tab) => {
            const on = tab.dataset.tab === id;
            tab.classList.toggle('is-active', on);
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          this.panels.forEach((panel) => {
            const on = panel.dataset.panel === id;
            panel.classList.toggle('is-active', on);
            panel.hidden = !on;
          });
        }
        scrollBy(dir) {
          const scroller = this.querySelector('.devices-figma__panel.is-active .devices-figma__scroller');
          if (!scroller) return;
          const card = scroller.querySelector('.devices-figma__card');
          const gap = parseFloat(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap) || 0;
          const amount = card ? card.getBoundingClientRect().width + gap : 280;
          scroller.scrollBy({ left: dir * amount, behavior: 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["essentials-figma"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('essentials-figma')) {
    customElements.define(
      'essentials-figma',
      class EssentialsFigma extends HTMLElement {
        connectedCallback() {
          this.tabs = this.querySelectorAll('[data-tab]');
          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.activate(tab.dataset.tab));
          });
          this.querySelectorAll('[data-dir]').forEach((btn) => {
            btn.addEventListener('click', () => this.scrollBy(Number(btn.dataset.dir)));
          });
        }
        activate(id) {
          this.tabs.forEach((tab) => {
            const on = tab.dataset.tab === id;
            tab.classList.toggle('is-active', on);
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          this.querySelectorAll('[data-banner], [data-copy], [data-panel]').forEach((el) => {
            const key = el.dataset.banner || el.dataset.copy || el.dataset.panel;
            const on = key === id;
            el.classList.toggle('is-active', on);
            el.hidden = !on;
          });
        }
        scrollBy(dir) {
          const scroller = this.querySelector('.essentials-figma__panel.is-active .essentials-figma__scroller');
          if (!scroller) return;
          const card = scroller.querySelector('.essentials-figma__card');
          const gap = parseFloat(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap) || 0;
          const amount = card ? card.getBoundingClientRect().width + gap : 280;
          scroller.scrollBy({ left: dir * amount, behavior: 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-figma"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('footer-figma-nav')) {
    customElements.define(
      'footer-figma-nav',
      class FooterFigmaNav extends HTMLElement {
        connectedCallback() {
          this.groups = this.querySelectorAll('details.ft-figma__group:not(.ft-figma__group--social)');
          this.mq = window.matchMedia('(min-width: 990px)');
          this.sync = this.sync.bind(this);
          this.mq.addEventListener('change', this.sync);
          this.sync();
        }
        disconnectedCallback() {
          this.mq.removeEventListener('change', this.sync);
        }
        sync() {
          this.groups.forEach((group) => {
            group.open = this.mq.matches;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-figma"]) return;
  try {
    
  if (!customElements.get('header-figma-menu')) {
    customElements.define(
      'header-figma-menu',
      class HeaderFigmaMenu extends HTMLElement {
        connectedCallback() {
          this.drawer = this.querySelector('#MenuDrawer');
          this.onMegaCat = this.onMegaCat.bind(this);
          this.onItemClick = this.onItemClick.bind(this);
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onDrawerClick = this.onDrawerClick.bind(this);
          this.resetDrawer = this.resetDrawer.bind(this);
          this.onResize = this.onResize.bind(this);
          this.onKeydown = this.onKeydown.bind(this);

          this.querySelectorAll('[data-mega-item] > .hdr-figma__link').forEach((link) => {
            link.addEventListener('click', this.onItemClick);
            // Desktop: after the first click opens a menu, hovering other items switches it
            link.addEventListener('mouseenter', () => {
              if (!this.canHover()) return;
              const item = link.closest('[data-mega-item]');
              if (!item || item.classList.contains('is-open')) return;
              if (!this.querySelector('[data-mega-item].is-open')) return;
              if (item.querySelector('.hdr-figma-mega')) this.openItem(item);
              else this.closeAllMegas();
            });
          });

          this.querySelectorAll('[data-mega-cat]').forEach((btn) => {
            btn.addEventListener('click', this.onMegaCat);
            btn.addEventListener('mouseenter', (event) => {
              if (!this.canHover() || btn.classList.contains('is-active')) return;
              this.onMegaCat({ currentTarget: btn });
            });
          });

          if (this.drawer) {
            this.drawer.addEventListener('click', this.onDrawerClick);
            this.drawer.addEventListener('drawer:afterHide', this.resetDrawer);
          }
          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('keydown', this.onKeydown);
          window.addEventListener('resize', this.onResize);
        }

        disconnectedCallback() {
          this.querySelectorAll('[data-mega-item] > .hdr-figma__link').forEach((link) => {
            link.removeEventListener('click', this.onItemClick);
          });
          this.querySelectorAll('[data-mega-cat]').forEach((btn) => {
            btn.removeEventListener('click', this.onMegaCat);
          });
          if (this.drawer) {
            this.drawer.removeEventListener('click', this.onDrawerClick);
            this.drawer.removeEventListener('drawer:afterHide', this.resetDrawer);
          }
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('keydown', this.onKeydown);
          window.removeEventListener('resize', this.onResize);
        }

        canHover() {
          return window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches;
        }

        openItem(item) {
          this.querySelectorAll('[data-mega-item]').forEach((node) => {
            const on = node === item;
            node.classList.toggle('is-open', on);
            const mega = node.querySelector('.hdr-figma-mega');
            const nodeLink = node.querySelector('.hdr-figma__link');
            if (mega) mega.hidden = !on;
            if (nodeLink) nodeLink.setAttribute('aria-expanded', on ? 'true' : 'false');
            if (on && mega) this.queueMegaLayout(mega);
          });
        }

        onItemClick(event) {
          const link = event.currentTarget;
          const item = link.closest('[data-mega-item]');
          if (!item || !item.querySelector('.hdr-figma-mega')) return;
          event.preventDefault();
          const willOpen = !item.classList.contains('is-open');
          this.querySelectorAll('[data-mega-item]').forEach((node) => {
            const on = willOpen && node === item;
            node.classList.toggle('is-open', on);
            const mega = node.querySelector('.hdr-figma-mega');
            const nodeLink = node.querySelector('.hdr-figma__link');
            if (mega) mega.hidden = !on;
            if (nodeLink) nodeLink.setAttribute('aria-expanded', on ? 'true' : 'false');
            if (on && mega) this.queueMegaLayout(mega);
          });
        }

        closeAllMegas() {
          this.querySelectorAll('[data-mega-item]').forEach((node) => {
            node.classList.remove('is-open');
            const mega = node.querySelector('.hdr-figma-mega');
            const link = node.querySelector('.hdr-figma__link');
            if (mega) mega.hidden = true;
            if (link) link.setAttribute('aria-expanded', 'false');
          });
        }

        onDocumentClick(event) {
          if (event.target.closest('[data-mega-item]')) return;
          this.closeAllMegas();
        }

        onKeydown(event) {
          if (event.key === 'Escape') this.closeAllMegas();
        }

        onMegaCat(event) {
          const btn = event.currentTarget;
          const mega = btn.closest('.hdr-figma-mega');
          if (!mega) return;
          const panelId = btn.getAttribute('aria-controls');
          mega.querySelectorAll('[data-mega-cat]').forEach((item) => {
            const on = item === btn;
            item.classList.toggle('is-active', on);
            item.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          mega.querySelectorAll('.hdr-figma-mega__panel').forEach((panel) => {
            panel.hidden = panel.id !== panelId;
          });
          this.queueMegaLayout(mega);
        }

        onResize() {
          const mega = this.querySelector('.hdr-figma__item.is-open > .hdr-figma-mega');
          if (mega) this.queueMegaLayout(mega);
        }

        queueMegaLayout(mega) {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => this.layoutMega(mega));
          });
        }

        layoutMega(mega) {
          if (!mega || mega.hidden) return;
          const panel = mega.querySelector('.hdr-figma-mega__panel:not([hidden])');
          if (!panel) return;
          const wrap = panel.querySelector('.hdr-figma-mega__cols');
          if (!wrap) return;
          const promos = panel.querySelector('.hdr-figma-mega__promos');
          panel.style.removeProperty('--hdr-mega-promo-w');

          wrap.classList.remove('is-packed');
          wrap.style.removeProperty('--hdr-mega-col-w');
          wrap.style.removeProperty('--hdr-mega-col-gap');
          wrap.querySelectorAll('.hdr-figma-mega__col').forEach((col) => {
            col.style.removeProperty('--col-span');
            col.style.removeProperty('--col-w');
          });
          wrap.querySelectorAll('.hdr-figma-mega__list').forEach((list) => {
            list.style.columnCount = '1';
            list.style.height = 'auto';
          });

          const theme = window.getComputedStyle(mega);
          const groupCount = wrap.querySelectorAll('.hdr-figma-mega__col').length;
          const isLaptop = window.matchMedia('(max-width: 1439px)').matches;
          const designColW = parseFloat(theme.getPropertyValue('--hdr-mega-col-w')) || 220;
          const designGap = parseFloat(theme.getPropertyValue('--hdr-mega-col-gap')) || 72;
          const designAside = 55;
          const minGap = isLaptop ? 20 : 24;
          const minAside = 24;
          const fitCol = isLaptop ? 136 : 88;
          let colW = designColW;
          let colGap = designGap;
          let asideGap = designAside;
          const promoCount = promos ? promos.children.length : 0;
          const gapsN = Math.max(0, groupCount - 1);
          const promoNeed = promoCount > 1 ? 255 * 2 + 24 : 533;
          const panelW = panel.clientWidth;
          const minColsW = groupCount * fitCol + gapsN * minGap;
          const showPromos = Boolean(promos && promoCount && panelW - minColsW - minAside >= promoNeed);
          const promoW = showPromos ? promoNeed : 0;
          const needed = (cw, cg, ag) =>
            groupCount * cw + gapsN * cg + (promoW ? ag + promoW : 0);
          if (groupCount && needed(colW, colGap, asideGap) > panelW + 0.5) {
            if (isLaptop) {
              const gapRoom = gapsN * (designGap - minGap) + (promoW ? designAside - minAside : 0);
              const overflow = needed(colW, colGap, asideGap) - panelW;
              if (gapRoom > 0 && overflow <= gapRoom) {
                const t = overflow / gapRoom;
                colGap = designGap - (designGap - minGap) * t;
                if (promoW) asideGap = designAside - (designAside - minAside) * t;
              } else {
                colGap = minGap;
                asideGap = promoW ? minAside : designAside;
                const remain = panelW - (promoW ? asideGap + promoW : 0) - gapsN * colGap;
                colW = Math.max(fitCol, Math.floor(remain / Math.max(1, groupCount)));
              }
            } else {
              const remain = panelW - (promoW ? asideGap + promoW : 0) - gapsN * colGap;
              colW = Math.max(88, Math.floor(remain / Math.max(1, groupCount)));
            }
          }
          wrap.style.setProperty('--hdr-mega-col-gap', colGap + 'px');
          wrap.style.setProperty('--hdr-mega-col-w', colW + 'px');
          panel.style.setProperty('--hdr-mega-aside-gap', asideGap + 'px');
          if (promos) {
            if (showPromos) {
              panel.classList.add('hdr-figma-mega__panel--aside-promo');
              promos.hidden = false;
            } else {
              promos.hidden = true;
              panel.classList.remove('hdr-figma-mega__panel--aside-promo');
            }
          }

          const availableH = wrap.clientHeight;
          const availableW = wrap.clientWidth;
          if (availableH < 40 || availableW < 80) return;

          if (isLaptop && groupCount) {
            const extra = availableW - (groupCount * colW + gapsN * colGap);
            if (extra >= groupCount) {
              colW += Math.floor(extra / groupCount);
              wrap.style.setProperty('--hdr-mega-col-w', colW + 'px');
            }
          }

          const packed = colW + 0.5 < designColW;
          const maxTracks = packed
            ? groupCount
            : Math.max(1, Math.floor((availableW + colGap) / (colW + colGap)));
          const trackWidth = (span, track = colW) => span * track + Math.max(0, span - 1) * colGap;
          const measureText = (el) => {
            if (!el) return 0;
            const range = document.createRange();
            range.selectNodeContents(el);
            let width = 0;
            Array.from(range.getClientRects()).forEach((rect) => {
              width = Math.max(width, rect.width);
            });
            return width;
          };

          const plans = Array.from(wrap.querySelectorAll('.hdr-figma-mega__col')).map((colEl) => {
            const list = colEl.querySelector('.hdr-figma-mega__list');
            const items = list ? list.children : [];
            const count = items.length;
            if (!list || !count) {
              return { colEl, list, count: 0, extra: 0, row: 24, gap: 10, compactW: colW, headingW: 0, shortWords: false };
            }

            const itemHeight = Math.max(
              ...Array.from(items, (item) => item.getBoundingClientRect().height)
            );
            const gap = 10;
            const row = itemHeight + gap;
            const heading = colEl.querySelector('.hdr-figma-mega__heading');
            const headingSpace = heading ? heading.getBoundingClientRect().height + 11 : 0;
            const maxListHeight = Math.max(row, availableH - headingSpace);
            const perColumn = Math.max(1, Math.floor((maxListHeight + gap) / row));
            const extra = Math.max(0, Math.ceil(count / perColumn) - 1);
            const shortWords = Array.from(items).every((item) => (item.textContent || '').trim().length <= 14);
            const maxItemW = Math.max(
              ...Array.from(items, (item) => measureText(item.querySelector('a') || item))
            );
            const compactW = Math.min(colW, Math.max(88, Math.ceil(maxItemW) + 8));
            const headingW = measureText(heading);
            return { colEl, list, count, extra, row, gap, shortWords, compactW, headingW, maxListHeight };
          });

          const spans = plans.map(() => 1);
          let leftover = packed ? 0 : maxTracks - spans.length;
          if (leftover > 0) {
            const order = plans
              .map((plan, index) => ({ index, extra: plan.extra, count: plan.count }))
              .filter((plan) => plan.extra > 0)
              .sort((a, b) => b.extra - a.extra || b.count - a.count);
            order.forEach((plan) => {
              if (leftover <= 0) return;
              const add = Math.min(plan.extra, leftover);
              spans[plan.index] += add;
              leftover -= add;
            });
          }

          const usedW = spans.reduce((sum, span) => sum + trackWidth(span), 0) + Math.max(0, spans.length - 1) * colGap;
          let leftoverPx = packed ? 0 : availableW - usedW;
          plans.forEach((plan, index) => {
            if (packed || !plan.shortWords || plan.extra <= 0 || spans[index] > 1 || leftoverPx < 8) return;
            const colCount = Math.min(plan.extra + 1, 3);
            const neededW = Math.max(plan.headingW, trackWidth(colCount, plan.compactW));
            const extraNeed = Math.max(0, neededW - trackWidth(spans[index]));
            if (leftoverPx + 0.5 < extraNeed) return;
            spans[index] = colCount;
            plan.trackW = (neededW - (colCount - 1) * colGap) / colCount;
            leftoverPx -= extraNeed;
          });

          plans.forEach((plan, index) => {
            if (!plan.list || !plan.count) return;
            const colCount = spans[index];
            if (colCount <= 1) {
              plan.list.style.columnCount = '1';
              plan.list.style.height = 'auto';
              plan.colEl.style.setProperty('--col-span', '1');
              return;
            }
            const balanced = Math.ceil(plan.count / colCount);
            const listH = Math.max(plan.maxListHeight, balanced * plan.row - plan.gap);
            plan.list.style.columnCount = String(colCount);
            plan.list.style.height = `${listH}px`;
            plan.colEl.style.setProperty('--col-span', String(colCount));
            if (plan.trackW) plan.colEl.style.setProperty('--col-w', plan.trackW + 'px');
          });
        }

        onDrawerClick(event) {
          const openBtn = event.target.closest('[data-open-panel]');
          if (openBtn) {
            event.preventDefault();
            this.openPanel(openBtn.getAttribute('data-open-panel'));
            return;
          }
          const closeBtn = event.target.closest('[data-close-panel]');
          if (closeBtn) {
            event.preventDefault();
            this.closePanel();
          }
        }

        syncDrawerBack() {
          if (!this.drawer) return;
          const back = this.drawer.querySelector('.hdr-figma-drawer__top .hdr-figma-drawer__back');
          const label = back ? back.querySelector('[data-back-label]') : null;
          const current = this.drawer.querySelector('.hdr-figma-drawer__panel.is-active');
          const title = current ? current.getAttribute('data-back-label') : '';
          if (!back) return;
          if (!title) {
            back.setAttribute('hidden', '');
            if (label) label.textContent = '';
            return;
          }
          back.removeAttribute('hidden');
          if (label) label.textContent = title;
        }

        openPanel(id) {
          if (!this.drawer) return;
          const next = this.drawer.querySelector('[data-panel="' + id + '"]');
          const current = this.drawer.querySelector('.hdr-figma-drawer__panel.is-active');
          if (!next || next === current) return;
          if (current) {
            current.classList.remove('is-active');
            current.classList.add('is-behind');
          }
          next.classList.remove('is-behind');
          next.classList.add('is-active');
          this.syncDrawerBack();
        }

        closePanel() {
          if (!this.drawer) return;
          const panel = this.drawer.querySelector('.hdr-figma-drawer__panel.is-active');
          if (!panel) return;
          const level = Number(panel.getAttribute('data-level') || '0');
          const prev = this.drawer.querySelector(
            '.hdr-figma-drawer__panel.is-behind[data-level="' + (level - 1) + '"]'
          ) || this.drawer.querySelector('.hdr-figma-drawer__panel[data-panel="root"]');
          panel.classList.remove('is-active');
          panel.classList.remove('is-behind');
          if (prev) {
            prev.classList.remove('is-behind');
            prev.classList.add('is-active');
          }
          this.syncDrawerBack();
        }

        resetDrawer() {
          if (!this.drawer) return;
          this.drawer.querySelectorAll('.hdr-figma-drawer__panel').forEach((panel) => {
            const isRoot = panel.getAttribute('data-panel') === 'root';
            panel.classList.toggle('is-active', isRoot);
            panel.classList.remove('is-behind');
          });
          this.syncDrawerBack();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-figma"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-countdown')) {
    customElements.define(
      'hero-countdown',
      class HeroCountdown extends HTMLElement {
        connectedCallback() {
          this.expires = new Date(this.dataset.expires);
          this.units = this.querySelectorAll('[data-unit]');
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        pad(value) {
          return String(Math.max(0, value)).padStart(2, '0');
        }
        tick() {
          const diff = this.expires.getTime() - Date.now();
          const days = Math.floor(diff / 86400000);
          const hours = Math.floor((diff % 86400000) / 3600000);
          const minutes = Math.floor((diff % 3600000) / 60000);
          const seconds = Math.floor((diff % 60000) / 1000);
          const map = { days, hours, minutes, seconds };
          this.units.forEach((el) => {
            el.textContent = this.pad(map[el.dataset.unit] || 0);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-figma"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-figma')) {
    customElements.define(
      'pdp-figma',
      class PdpFigma extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('[data-pdp-thumb]').forEach((btn) => {
            btn.addEventListener('click', () => this.swapMain(btn));
          });
          this.initMobileGallery();
          this.initLightbox();
          this.querySelectorAll('[data-pdp-open]').forEach((btn) => {
            btn.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              const id = btn.getAttribute('data-pdp-open');
              const dialog = id ? document.getElementById(id) : null;
              if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
            });
          });
          this.querySelectorAll('.pdp-figma__linkrow--vat').forEach((row) => {
            row.addEventListener('click', (event) => {
              if (event.target.closest('[data-pdp-open], dialog, a, button')) return;
              const opener = row.querySelector('.pdp-figma__linkrow-go[data-pdp-open]');
              if (opener) opener.click();
            });
          });
          // Wishlist off for now
          // this.querySelectorAll('[data-pdp-wish]').forEach((btn) => {
          //   btn.addEventListener('click', () => {
          //     btn.classList.toggle('is-on');
          //   });
          // });
          this.initSticky();
          this.initInfoSheet();
        }
        initSticky() {
          const bar = this.querySelector('[data-pdp-sticky]');
          const atc = this.querySelector('.pdp-figma__atc');
          const form = this.querySelector('.pdp-figma__form') || atc;
          if (!bar || !atc) return;
          this._stickyBar = bar;
          if (bar.parentElement !== document.body) document.body.appendChild(bar);
          const chromeSelectors = '#preview-bar-iframe, #PBarNextFrame, #shopify-preview-bar';
          const measureChrome = () => {
            let height = 0;
            document.querySelectorAll(chromeSelectors).forEach((el) => {
              height = Math.max(height, el.getBoundingClientRect().height, el.offsetHeight || 0);
            });
            if (document.querySelector(chromeSelectors) && height < 40) height = 56;
            document.documentElement.style.setProperty('--pdp-chrome-bottom', height + 'px');
            return height;
          };
          const setOn = (on) => {
            bar.classList.toggle('is-on', on);
            if (on) bar.removeAttribute('hidden');
            else bar.setAttribute('hidden', '');
          };
          const headerOffset = () => {
            const raw = getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height')
              || getComputedStyle(document.documentElement).getPropertyValue('--header-height');
            const n = parseFloat(raw);
            return Number.isFinite(n) ? n : 90;
          };
          const sync = () => {
            measureChrome();
            const rect = atc.getBoundingClientRect();
            if (rect.width < 2 && rect.height < 2) {
              setOn(false);
              return;
            }
            setOn(rect.bottom < headerOffset() + 8);
          };
          this._stickyObserver = new IntersectionObserver(() => sync(), {
            threshold: [0, 0.01, 1],
          });
          this._stickyObserver.observe(atc);
          this._stickyOnScroll = () => {
            if (this._stickyRaf) return;
            this._stickyRaf = requestAnimationFrame(() => {
              this._stickyRaf = 0;
              sync();
            });
          };
          window.addEventListener('scroll', this._stickyOnScroll, { passive: true });
          window.addEventListener('resize', this._stickyOnScroll);
          document.addEventListener('scroll', this._stickyOnScroll, { passive: true, capture: true });
          if (window.visualViewport) {
            window.visualViewport.addEventListener('scroll', this._stickyOnScroll, { passive: true });
            window.visualViewport.addEventListener('resize', this._stickyOnScroll);
          }
          this._stickyChromeWatch = new MutationObserver(measureChrome);
          this._stickyChromeWatch.observe(document.body, { childList: true });
          measureChrome();
          setOn(false);
          requestAnimationFrame(() => requestAnimationFrame(sync));
          window.addEventListener('load', sync);
          bar.querySelectorAll('[data-pdp-tab]').forEach((tab) => {
            tab.addEventListener('click', (event) => {
              event.preventDefault();
              const target = document.querySelector(tab.getAttribute('href'));
              if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
              bar.querySelectorAll('[data-pdp-tab]').forEach((el) => {
                el.classList.toggle('is-active', el === tab);
              });
            });
          });
          const topBtn = bar.querySelector('[data-pdp-top]');
          if (topBtn) {
            topBtn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
          }
          const sections = ['pdp-description', 'pdp-specs', 'pdp-faq']
            .map((id) => document.getElementById(id))
            .filter(Boolean);
          if (sections.length) {
            this._tabObserver = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (!entry.isIntersecting) return;
                  const href = '#' + entry.target.id;
                  bar.querySelectorAll('[data-pdp-tab]').forEach((el) => {
                    el.classList.toggle('is-active', el.getAttribute('href') === href);
                  });
                });
              },
              { rootMargin: '-35% 0px -55% 0px', threshold: 0 }
            );
            sections.forEach((el) => this._tabObserver.observe(el));
          }
        }
        initInfoSheet() {
          const sheet = document.getElementById('pdp-info-sheet');
          if (!sheet) return;
          this._infoSheet = sheet;
          sheet.querySelectorAll('[data-sheet-tab]').forEach((btn) => {
            btn.addEventListener('click', () => this.setInfoSheetTab(btn.getAttribute('data-sheet-tab')));
          });
          sheet.querySelectorAll('[data-sheet-close]').forEach((btn) => {
            btn.addEventListener('click', () => {
              if (typeof sheet.close === 'function') sheet.close();
            });
          });
          this.querySelectorAll('[data-pdp-sheet]').forEach((link) => {
            link.addEventListener('click', (event) => {
              if (!window.matchMedia('(max-width: 989px)').matches) return;
              event.preventDefault();
              this.openInfoSheet(link.getAttribute('data-pdp-sheet'));
            });
          });
        }
        setInfoSheetTab(tab) {
          const sheet = this._infoSheet || document.getElementById('pdp-info-sheet');
          if (!sheet) return;
          sheet.querySelectorAll('[data-sheet-tab]').forEach((btn) => {
            btn.classList.toggle('is-on', btn.getAttribute('data-sheet-tab') === tab);
          });
          sheet.querySelectorAll('[data-sheet-panel]').forEach((panel) => {
            panel.classList.toggle('is-on', panel.getAttribute('data-sheet-panel') === tab);
          });
          const body = sheet.querySelector('.pdp-info-sheet__body');
          if (body) body.scrollTop = 0;
        }
        openInfoSheet(tab) {
          const sheet = this._infoSheet || document.getElementById('pdp-info-sheet');
          if (!sheet || typeof sheet.showModal !== 'function') return;
          const descPanel = sheet.querySelector('[data-sheet-panel="desc"]');
          const src = document.getElementById('pdp-description');
          if (descPanel && src && !descPanel.dataset.filled) {
            const clone = src.cloneNode(true);
            clone.removeAttribute('id');
            descPanel.replaceChildren(...Array.from(clone.children));
            descPanel.dataset.filled = '1';
          }
          const tfHasDesc = !!sheet.querySelector('[data-sheet-tab="desc"]');
          this.setInfoSheetTab(tfHasDesc ? (tab || 'desc') : 'specs');
          if (!sheet.open) sheet.showModal();
        }
        disconnectedCallback() {
          if (this._stickyObserver) this._stickyObserver.disconnect();
          if (this._stickyChromeWatch) this._stickyChromeWatch.disconnect();
          if (this._stickyRaf) cancelAnimationFrame(this._stickyRaf);
          if (this._stickyOnScroll) {
            window.removeEventListener('scroll', this._stickyOnScroll);
            window.removeEventListener('resize', this._stickyOnScroll);
            document.removeEventListener('scroll', this._stickyOnScroll, { capture: true });
            if (window.visualViewport) {
              window.visualViewport.removeEventListener('scroll', this._stickyOnScroll);
              window.visualViewport.removeEventListener('resize', this._stickyOnScroll);
            }
          }
          if (this._stickyBar && this._stickyBar.parentElement === document.body) {
            this._stickyBar.remove();
          }
          if (this._tabObserver) this._tabObserver.disconnect();
        }
        initMobileGallery() {
          const track = this.querySelector('[data-pdp-track]');
          const dots = this.querySelectorAll('[data-pdp-dot]');
          if (!track || !dots.length) return;
          const setDot = (index) => {
            dots.forEach((dot, i) => dot.classList.toggle('is-on', i === index));
          };
          track.addEventListener(
            'scroll',
            () => {
              const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
              setDot(Math.max(0, Math.min(index, dots.length - 1)));
            },
            { passive: true }
          );
          dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
              track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
              setDot(index);
            });
          });
        }
        initLightbox() {
          const lb = this.querySelector('[data-pdp-lb]');
          const opener = this.querySelector('[data-pdp-lb-open]');
          if (!lb || !opener) return;
          document.body.appendChild(lb);
          const slides = Array.from(lb.querySelectorAll('[data-pdp-lb-slide]'));
          const thumbs = Array.from(lb.querySelectorAll('[data-pdp-lb-thumb]'));
          const cur = lb.querySelector('[data-pdp-lb-cur]');
          let index = 0;
          const show = (i) => {
            index = (i + slides.length) % slides.length;
            slides.forEach((s, n) => {
              const on = n === index;
              s.classList.toggle('is-on', on);
              const img = s.querySelector('img');
              if (on && img && !img.src) img.src = img.dataset.src;
            });
            thumbs.forEach((t, n) => t.classList.toggle('is-on', n === index));
            if (thumbs[index]) thumbs[index].scrollIntoView({ block: 'nearest', inline: 'center' });
            if (cur) cur.textContent = index + 1;
          };
          const onKey = (e) => {
            if (e.key === 'Escape') close();
            else if (e.key === 'ArrowRight') show(index + 1);
            else if (e.key === 'ArrowLeft') show(index - 1);
          };
          const open = () => {
            const main = this.querySelector('[data-pdp-main]');
            lb.hidden = false;
            document.documentElement.style.overflow = 'hidden';
            document.addEventListener('keydown', onKey);
            show(parseInt((main && main.dataset.index) || '0', 10) || 0);
          };
          const close = () => {
            lb.hidden = true;
            document.documentElement.style.overflow = '';
            document.removeEventListener('keydown', onKey);
          };
          opener.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); open(); });
          lb.querySelector('[data-pdp-lb-close]')?.addEventListener('click', close);
          lb.querySelector('[data-pdp-lb-prev]')?.addEventListener('click', () => show(index - 1));
          lb.querySelector('[data-pdp-lb-next]')?.addEventListener('click', () => show(index + 1));
          thumbs.forEach((t) => t.addEventListener('click', () => show(parseInt(t.dataset.index, 10))));
          lb.querySelector('.pdp-figma__lb-stage')?.addEventListener('click', (e) => {
            if (e.target.classList.contains('pdp-figma__lb-slide')) close();
          });
        }
        swapMain(btn) {
          const mainEl = this.querySelector('[data-pdp-main]');
          if (mainEl && btn.dataset.index) mainEl.dataset.index = btn.dataset.index;
          const mainImg = this.querySelector('[data-pdp-main] img');
          if (!mainImg) return;
          const next = btn.getAttribute('data-src');
          const srcset = btn.getAttribute('data-srcset');
          if (next) mainImg.src = next;
          if (srcset) mainImg.srcset = srcset;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-related-figma"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-related-figma')) {
    customElements.define(
      'pdp-related-figma',
      class PdpRelatedFigma extends HTMLElement {
        connectedCallback() {
          this.tabs = this.querySelectorAll('[data-related-tab]');
          this.panels = this.querySelectorAll('[data-related-panel]');
          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.activate(tab.dataset.relatedTab));
          });
        }
        activate(id) {
          this.tabs.forEach((tab) => {
            const on = tab.dataset.relatedTab === id;
            tab.classList.toggle('is-active', on);
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          this.panels.forEach((panel) => {
            const on = panel.dataset.relatedPanel === id;
            panel.classList.toggle('is-active', on);
            panel.hidden = !on;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-figma"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reviews-figma')) {
    customElements.define(
      'reviews-figma',
      class ReviewsFigma extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          if (this.slides.length < 2) return;
          this.index = 0;
          this.timer = null;
          this.startX = 0;
          this.bind();
          this.go(0, false);
          this.start();
        }
        disconnectedCallback() {
          this.stop();
        }
        bind() {
          this.slides.forEach((slide, i) => {
            slide.addEventListener('click', () => {
              if (i !== this.index) this.go(i);
            });
          });
          this.addEventListener('pointerdown', (event) => {
            this.startX = event.clientX;
          });
          this.addEventListener('pointerup', (event) => {
            const delta = event.clientX - this.startX;
            if (Math.abs(delta) < 40) return;
            this.go(this.index + (delta < 0 ? 1 : -1));
          });
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
        }
        go(next) {
          const total = this.slides.length;
          this.index = ((next % total) + total) % total;
          this.style.setProperty('--reviews-index', String(this.index));
          this.slides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === this.index);
          });
          this.start();
        }
        start() {
          this.stop();
          if (this.dataset.autoplay !== 'true') return;
          const speed = Number(this.dataset.speed || 6) * 1000;
          this.timer = setInterval(() => this.go(this.index + 1), speed);
        }
        stop() {
          if (this.timer) clearInterval(this.timer);
          this.timer = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tf-footer-balanced"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('footer-figma-nav')) {
    customElements.define(
      'footer-figma-nav',
      class FooterFigmaNav extends HTMLElement {
        connectedCallback() {
          this.groups = this.querySelectorAll('details.ft-figma__group:not(.ft-figma__group--social)');
          this.mq = window.matchMedia('(min-width: 990px)');
          this.sync = this.sync.bind(this);
          this.mq.addEventListener('change', this.sync);
          this.sync();
        }
        disconnectedCallback() {
          this.mq.removeEventListener('change', this.sync);
        }
        sync() {
          this.groups.forEach((group) => {
            group.open = this.mq.matches;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
